export default "__VITE_ASSET__hV41GDqF__"